import React from 'react';
import { Checkbox } from '@nicheinc/campus-ds';

import { TableMapperType } from '../../types';

type PropsType = {
	mapperField: TableMapperType;
	item: any;
};

function CheckBoxCell({ mapperField, item }: PropsType) {
	const isDisabled =
		typeof mapperField.isDisabled === 'function'
			? mapperField.isDisabled(item)
			: mapperField.isDisabled;

	return (
		<Checkbox
			ariaLabel="checkbox"
			checked={mapperField.checkedItemKey && item[mapperField.checkedItemKey]}
			onChange={(check) =>
				mapperField.onCheck && mapperField.onCheck(item, check)
			}
			disabled={isDisabled}
		/>
	);
}

export default CheckBoxCell;
